import React, { useContext, useEffect, useState } from "react";
import { Button, Table, Form, InputGroup, Pagination } from "react-bootstrap";
import { Store } from "../../Store";
import ToastIt from "../../components/Toast";
import ConfirmIt from "../../Utils/ConfirmIt";
import { CSVLink } from "react-csv";
import axios from "axios";
import { Trash } from "react-bootstrap-icons";

function AdminOrders() {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo, baseUrl, orderHistory } = state;

  const [Orders, setOrders] = useState([]);
  const [orderToProcess, setOrderToProcess] = useState(null);
  const [confirmAction, setConfirmAction] = useState(null);
  const [csvData, setCsvData] = useState([]);

  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [variance, setVariance] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  // fetch update from state
  useEffect(() => {
    if (orderHistory && orderHistory.length > 0) {
      setOrders(orderHistory);
    } else {
      setOrders([]);
    }
  }, [orderHistory]);

  // Filtered Orders
  const filteredOrders = Orders.filter((order) =>
    // order.receiver.includes(search)
    Object.values(order).some(
      (value) =>
        value && value.toString().toLowerCase().includes(search.toLowerCase())
    )
  );

  // Pagination Logic
  const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
  const paginatedOrders = filteredOrders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDeleteOrder = async (orderId) => {
   if(window.confirm(
      `Are you sure you want to delete order ${orderId.id}?`
    )){
      try {
              // Send DELETE request to the backend
              await axios.delete(`${baseUrl}/order/delete/${orderId._id}`, {
                headers: { Authorization: `Bearer ${userInfo.token}` },
              });
          
              // Update the Orders state to remove the deleted order
              setOrders((prevOrders) => prevOrders.filter((order) => order._id !== orderId._id));
               setToastMessage(`Order ${orderId.id} has been successfully deleted.`);
                setVariance("success");
                setShowToast(true);
               
            } catch (error) {
              console.error("Error deleting order:", error);
               setToastMessage("Failed to delete the order. Please try again");
                setVariance("danger");
                setShowToast(true);
            }

    }else{
      return;
    }
}

  const handleComplete = (orderID) => {
    setShowConfirm(true);
    setAlertMessage(
      `Are you sure you want to mark order ${orderID.id} as completed?`
    );
    setOrderToProcess(orderID._id);
    setConfirmAction("complete");
  };
  const handleProcess = (orderID) => {
    setShowConfirm(true);
    setAlertMessage(
      `Are you sure you want to mark order ${orderID.id} as processing?`
    );
    setOrderToProcess(orderID._id);
    setConfirmAction("process");
  };

  const handleReject = (orderID) => {
    setShowConfirm(true);
    setAlertMessage(`Are you sure you want to reject order ${orderID.id}?`);
    setOrderToProcess(orderID._id);
    setConfirmAction("reject");
  };

  function sendSMS(phoneNumber, Package, Beneficiary, Reference) {
    // console.log('for sms',phoneNumber, Package, Beneficiary, Reference);
    if (phoneNumber) {
      try {
        const apiUrl = `https://apps.mnotify.net/smsapi?key=zwNY4rjo1XWnMXn8Om7Q8gk1U&to=233${phoneNumber}&msg=Congratulations! you have successfully purchased ${Package} of Data for ${Beneficiary}. Reference: ${Reference}&sender_id=KYE-TECH`;
        fetch(apiUrl).then((response) => response.json(response.data));
      } catch (error) {
        console.error("Error sending SMS:", error);
      }
    }
  }

  const confirmActionHandler = async () => {
    try {
      const { data } = await axios.put(
        `${baseUrl}/order/update-status/${orderToProcess}`,
        { status: confirmAction === "reject" ? "rejected" : confirmAction === "process"? "processing":"completed" },
        {
          headers: { Authorization: `Bearer ${userInfo.token}` },
        }
      );

      const updatedOrders = Orders.map((order) =>
        order._id === orderToProcess
          ? {
              ...order,
              status: data.order.status,
              actionTimestamp: data.order.actionTimestamp,
            }
          : order
      );

      setOrders(updatedOrders);
      ctxDispatch({ type: "ORDER_HISTORY_UPDATE", payload: updatedOrders }); // Update global state
      // localStorage.setItem('orderHistory', JSON.stringify(updatedOrders));

      if (confirmAction === "reject") {
        setToastMessage(`Order ${orderToProcess} rejected`);
        setVariance("danger");
      } else if (confirmAction === "complete") {
        setToastMessage(`Order ${orderToProcess} completed`);
        setVariance("success");

// USER SMS NOTIFICATION
      const completedOrder = updatedOrders.find(order => order._id === orderToProcess);
      // console.log('completedOrder:', completedOrder);
      sendSMS(completedOrder.agentPhoneNumber, completedOrder.offer, completedOrder.receiver, completedOrder.reference);
        // alert('SMS sent to user');

      } else if (confirmAction === "process"){
        setToastMessage(`Order ${orderToProcess} processing`)
        setVariance("warning");
      }
    } catch (error) {
      setToastMessage("Error updating order status:", error);
      setVariance("success");
    }
    setShowConfirm(false);
    setShowToast(true);
  };

  //  FETCH ORDERS
  // useEffect(() => {
  //   const fetchOrders = async () => {
  //     try {
  //       const { data } = await axios.get(`${baseUrl}/order/allorders`, {
  //         headers: { Authorization: `Bearer ${userInfo.token}` },
  //       });
  //       setOrders(data.sort((a, b) => new Date(b.date) - new Date(a.date)));
  //     } catch (error) {
  //       alert('Error fetching transactions:', error);
  //     }
  //   };
  //   fetchOrders();
  //   // const handleStorageChange = (event) => {
  //   //   if (event.key === 'orderHistory') {
  //   //     const updatedOrderHistory = JSON.parse(event.newValue);
  //   //     setOrders(updatedOrderHistory.sort((a, b) => new Date(b.date) - new Date(a.date)));
  //   //   }
  //   // };

  //   // window.addEventListener('storage', handleStorageChange);

  //   // return () => {
  //   //   window.removeEventListener('storage', handleStorageChange);
  //   // };
  // }, [userInfo,baseUrl])

    const deleteAllOrders = async () => {
         if(window.confirm(`Are you sure you want to delete all orders?`)){
      try {
        // await axios.delete(`${baseUrl}/order/del-all-orders`);
        // setOrders([]);
        setToastMessage(`All orders deleted successfully`);
        setVariance("success");
        setShowToast(true);
      } catch (error) {
        console.error('Error deleting webhook:', error);
        setToastMessage(`Error deleting all orders`);
        setVariance("danger");
        setShowToast(true);
      }
      } else{
        return;
      }
    };

  // FOR CSV DATA
  useEffect(() => {
    const csvData = Orders.map((order) => ({
      ID: order.id,
      Agent: order.agent,
      Network: order.network,
      Beneficiary: order.receiver,
      Package: order.offer,
      Reference: order.reference,
      Date: order.date,
      Status: order.status,
      TotalAmount: order.totalAmount,
      DecidedTimestamp: order.actionTimestamp,
    }));
    setCsvData(csvData);
  }, [Orders]);

  // CSS STYLING
  const formContainerStyle = {
    flex: 1,
  };

  return (
    <>
      <div className="container mt-3 py-1" style={formContainerStyle}>
        <h3 className="text-center text-primary">MANAGE ORDERS

          
        </h3>
        <span className="float-end text-danger" style={{cursor:'pointer'}} onClick={() => deleteAllOrders()}>DELETE ALL ORDERS</span>
        <hr />

        <div className="d-flex justify-content-between mb-2">
          <Form.Group controlId="entriesSelect">
            <Form.Label>Show</Form.Label>{' '}
            <Form.Control
              as="select"
              value={itemsPerPage}
              onChange={(e) => setItemsPerPage(Number(e.target.value))}
              style={{ width: "auto", display: "inline-block" }}
            >
              {[5, 10, 20, 50].map((value) => (
                <option key={value} value={value}>
                  {value}
                </option>
              ))}
            </Form.Control>
            <span> entries</span>
          </Form.Group>
          <InputGroup className="search-bar" style={{ maxWidth: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </div>
        <div style={{ overflowX: "auto", fontSize: "11px" }}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>User</th>
                <th>Beneficiary</th>
                <th>Package</th>
                <th>Reference</th>
                <th>Payment</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Action</th>
                {/* <th>Time</th> */}
              </tr>
            </thead>
            <tbody>
              {paginatedOrders.map((order, index) => (
                <tr key={index}>
                  <td>{order.id}</td>
                  <td>{order.agent}</td>
                  <td>{order.receiver}</td>
                  <td>{order.network} - {order.offer}</td>
                  <td>{order.reference}</td>
                  <td><small>{order.date}</small></td>
                  <td>&cent; {order.totalAmount}</td>
                  <td>{order.status}</td>
                  <td>
                    {order.status === "pending" ? (
                      <>
                        <Button
                          variant="success"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleProcess(order)}
                          >
                          <small>Process</small>
                        </Button>{" "}
                        <Button
                          variant="danger"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleReject(order)}
                          >
                          <small>Reject</small>
                        </Button>
                      </>
                    ) : order.status === "completed" ? (
                      <Button
                      variant="success"
                      size="sm"
                      className="px-1 py-0 w-100"
                      disabled
                      >
                        <small>Completed</small>
                      </Button>
                    ) : order.status ==="processing"?(
                      <>
                        <Button
                          variant="success"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleComplete(order)}
                          >
                          <small>Complete</small>
                        </Button>{" "}
                        <Button
                          variant="danger"
                          size="sm"
                          className="px-1 py-0"
                          onClick={() => handleReject(order)}
                          >
                          <small>Reject</small>
                        </Button>
                      </>
                    ):(
                      <Button
                        variant="danger"
                        size="sm"
                        className="px-1 py-0 w-100"
                        disabled
                      >
                        <small>Rejected</small>
                      </Button>
                    )} &nbsp; <small>{order.actionTimestamp}</small>
                  </td>
                  <td onClick={() => handleDeleteOrder(order)} style={{cursor:'pointer'}}>
                    <small><Trash size={15}/></small>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-between">
          <span>
            Showing {paginatedOrders.length} of {filteredOrders.length} entries
          </span>
          <Pagination>
            {[...Array(totalPages)].map((_, index) => (
              <Pagination.Item
                key={index}
                // active={index + 1 === currentPage}
                 
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      <CSVLink
        className="btn btn-primary p-2 my-5 text-center w-100"
        data={csvData}
        filename={"GhanaBundles-admin-orders.csv"}
      >
        Export to Excel
      </CSVLink>
      </div>
      <ToastIt
        Variance={variance}
        Message={toastMessage}
        ShowToast={showToast}
        OnClose={() => setShowToast(false)}
      />
      <ConfirmIt
        Message={alertMessage}
        ShowConfirm={showConfirm}
        OnClose={() => setShowConfirm(false)}
        onConfirm={confirmActionHandler}
      />
    </>
  );
}

export default AdminOrders;
